import React from 'react';

const DamageProtectionIcon = () => (
  <svg width={44} height={44} viewBox="0 0 44 44" fill="none">
    <g
      clipPath="url(#clip0)"
      fillRule="evenodd"
      clipRule="evenodd"
      fill="#B20094"
    >
      <path d="M14.728 26.98h14.556V18.2l-7.278-5.47-7.278 5.47v8.78zm15.769 2.43H13.514A1.21 1.21 0 0112.3 28.2V17.59c0-.38.18-.74.486-.97l8.49-6.38a1.226 1.226 0 011.457 0l8.49 6.38c.306.23.486.59.486.97V28.2c0 .67-.543 1.21-1.213 1.21z" />
      <path d="M38.751 7.622v18.88c0 2.72-2.047 5.87-5.764 8.87-3.162 2.55-7.262 4.8-10.99 6.02-3.729-1.22-7.829-3.47-10.99-6.02-3.718-3-5.765-6.15-5.765-8.87V7.623l16.755-5.02 16.754 5.02zm1.634-2.16L22.36.053c-.238-.07-.49-.07-.729 0L3.606 5.463a1.28 1.28 0 00-.906 1.22v19.82c0 4.59 3.824 8.55 7.031 11.07 4.172 3.27 9.012 5.48 11.89 6.37.12.04.245.06.376.06.13 0 .257-.02.376-.06 2.878-.89 7.718-3.1 11.888-6.37 3.208-2.52 7.032-6.48 7.032-11.07V6.683c0-.57-.365-1.06-.908-1.22z" />
    </g>
    <defs>
      <clipPath id="clip0">
        <path d="M0 0h44v44H0V0z" fill="#fff" />
      </clipPath>
    </defs>
  </svg>
);

export default DamageProtectionIcon;
